import {
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  DialogContentText,
  CircularProgress,
  Typography,
  Paper,
  Box,
  Chip,
} from "@mui/material";

const ConfirmationModal = ({
  open,
  handleClose,
  jobIds,
  title,
  message,
  onConfirm,
  actionLoadingText,
  ActionBtnText,
  loading,
}) => {
  if (!jobIds) return null;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxWidth: 600,
        },
      }}
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>

        <Box sx={{ my: 2 }}>
          <Typography variant="subtitle2" gutterBottom sx={{ mt: 1 }}>
            Selected {jobIds.length === 1 ? "Order" : "Orders"}: {jobIds.length}
          </Typography>
          {jobIds.length > 0 ? (
            <Paper
              sx={{
                maxHeight: 400, // Limit height and allow scrolling if many chips
                overflowY: "auto",
                p: 1,
                bgcolor: "#f5f5f5",
                border: "1px solid #ddd",
                borderRadius: 1,
              }}
              elevation={0} // Remove default shadow for a flatter look
            >
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {jobIds.map((id) => (
                  <Chip
                    key={id}
                    label={id}
                    size="small"
                    variant="outlined"
                    sx={{ m: 0.25 }}
                  />
                ))}
              </Box>
            </Paper>
          ) : (
            <Typography variant="body2" color="textSecondary">
              No orders selected.
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          variant="outlined"
          onClick={handleClose}
          sx={{ mr: 1, borderRadius: 1 }}
        >
          Cancel
        </Button>

        <Button
          variant="contained"
          color="success"
          sx={{
            borderRadius: 1,
          }}
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? actionLoadingText : ActionBtnText}
          {loading && (
            <CircularProgress color="success" size={18} sx={{ ml: 1 }} />
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;
